import { useState } from 'react';
import HelperUtil from '~/utils/HelperUtils';
import { ethers } from 'ethers';
import tokenAbi from '../config/abi/ERC20Token.json';

function Test() {
  const [loading, setLoading] = useState(false);
  const [order, setOrder] = useState();
  const [offer, setOffer] = useState();
  const target = 1001;

  const test1Handler = async () => {
    try {
      setLoading(true);
      console.log(1);
      const abcUser = JSON.parse(
        window.sessionStorage.getItem('abcUser') || '{}'
      );
      const ethAddress = abcUser?.accounts[0]?.ethAddress;
      const provider = await HelperUtil.getAbcWeb3Provider(target);
      console.log('provider:::', provider);

      console.log('!! My ABC Wallet Address ', ethAddress);
      const contract = new ethers.Contract(
        '0x1459c0eA227092987FC92b824001eBA3d7dB920F',
        tokenAbi,
        provider.getSigner()
      );
      console.log('contract:::', contract.signer);

      const address = await provider.getSigner().getAddress();
      console.log('>>>>> ', address);

      const usdt = await contract.balanceOf(
        '0x1716C4d49E9D81c17608CD9a45b1023ac9DF6c73'
      );
      console.log('==>', ethers.utils.formatUnits(usdt, 6));

      // const params = [
      //   {
      //     from: address,
      //     to: address,
      //     value: ethers.utils.parseUnits('0.1', 'ether').toHexString(),
      //     gasLimit: '21000',
      //   },
      // ];
      // const transactionHash = await provider.send(
      //   'eth_sendTransaction',
      //   params
      // );
      // console.log('transactionHash is ' + transactionHash);

      let tx = await contract.approve(
        address,
        ethers.utils.parseUnits('0.1', 6).toHexString()
      );
      let receipt = await tx.wait();
      console.log('>>>>>>>', receipt);

      tx = await contract.transferFrom(
        address,
        address,
        ethers.utils.parseUnits('0.1', 6).toHexString()
      );
      receipt = await tx.wait();
      console.log('>>>>>>>', receipt);
    } catch (err: any) {
      console.log(err.message);
      alert(err.message);
    } finally {
      setLoading(false);
    }
  };

  // const makeOrderHandler = async () => {
  //   try {
  //     setLoading(true);
  //     console.log('!! start make order ...');
  //     const abcUser = JSON.parse(window.localStorage.getItem('abcUser'));
  //     const ethAddress = abcUser?.accounts[0]?.ethAddress;
  //     const provider = await HelperUtil.getAbcWeb3Provider(target);
  //     console.log('provider:::', provider, provider.provider.chainId);
  //     console.log('ABC Address:::', ethAddress);
  //
  //     let order;
  //     try {
  //       // Fixed Price
  //       order = await seaport.createOrder({
  //         signer: provider,
  //         tokenContractAddress: '0x895314741fbc297d6de5a9f4d70c543955523e7b',
  //         tokenId: '508',
  //         itemType: 2,
  //         price: '1',
  //         quoteContractAddress: contracts.usdc[1001], // Taklen USDT
  //         endTime: '1701053342', // one month
  //         creatorAddress: '0x1716C4d49E9D81c17608CD9a45b1023ac9DF6c73',
  //         zone: '0xdc926E34E73292cD7c48c6fD7375af7D93435D36',
  //         quote: 'usdc',
  //       });
  //       // English Auction
  //       // order = await seaport.createOrder({
  //       //   signer: provider,
  //       //   tokenContractAddress: '0x7ec53338105c70b726283ab3bfd8110f8835198f',
  //       //   tokenId: '13',
  //       //   price: '0',
  //       //   quoteContractAddress: contracts.usdc[1001], // Taklen USDT
  //       //   endTime: '1701053342', // one month
  //       //   creatorAddress: '0x1716C4d49E9D81c17608CD9a45b1023ac9DF6c73',
  //       // });
  //       setOrder(order);
  //       console.log('!!!!!!!!!!!!!!!!!!', order);
  //     } catch (e) {
  //       console.log('!!!!! create order error', e.message);
  //     }
  //   } catch (err) {
  //     console.log(err.message);
  //     alert(err.message);
  //   } finally {
  //     setLoading(false);
  //   }
  // };

  const getMyBalanceButton = () => {
    return (
      <button
        onClick={test1Handler}
        disabled={loading}
        className="cta-button claim-button"
      >
        {loading ? 'Processing' : 'test1'}
      </button>
    );
  };
  // const makeOrder = () => {
  //   // seaport test
  //   return (
  //     <button
  //       onClick={makeOrderHandler}
  //       disabled={loading}
  //       className="cta-button claim-button"
  //     >
  //       {loading ? 'Processing' : 'Make Order'}
  //     </button>
  //   );
  // };

  return (
    <div className="main-app">
      <>
        <h1>Test Page</h1>
        <br />
        <div className="button-div">{getMyBalanceButton()}</div>
        <br />
        {/*<br />*/}
        {/*<div className="button-div">{makeOrder()}</div>*/}
        {/*<br />*/}
      </>
    </div>
  );
}

export default Test;
